import { useCallback, useState } from 'react';
import { LayoutAnimation } from 'react-native';
import { updateCategoriesPreferences } from 'actions';
import { useAppDispatch, useAppSelector, useAppStore } from 'store/hooks';
import useRequiredTierCallback from 'features/premium/hooks/useRequiredTierCallback';
import { selectParentCategories } from 'reducers/selectors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { Tier } from 'features/premium/entities';
import { sortByName } from 'utils/sort';
export const useReorderCategories = () => {
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const categories = useAppSelector(selectParentCategories);
    const [visibleCategoriesOrder, setVisibleCategoriesOrder] = useState(() => categories.filter((category) => (category.priority ?? 0) !== -1));
    const [hiddenCategories, setHiddenCategories] = useState(() => categories.filter((category) => (category.priority ?? 0) === -1));
    const store = useAppStore();
    const handleDone = useRequiredTierCallback(useCallback(async () => {
        const { categories, customCategories } = store.getState().user;
        const prevCategoriesState = {
            categories,
            customCategories,
        };
        const categoryPreferences = visibleCategoriesOrder
            .map((category, index) => ({
            categoryId: category.id,
            priority: index + 1,
        }))
            .concat(hiddenCategories.map((category) => ({
            categoryId: category.id,
            priority: -1,
        })));
        dispatch(updateCategoriesPreferences(categoryPreferences, prevCategoriesState));
        navigation.pop();
    }, [hiddenCategories, visibleCategoriesOrder]), Tier.pro);
    const onRevertOrder = useCallback(() => {
        LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
        setVisibleCategoriesOrder((prev) => sortByName([...prev]));
    }, []);
    const onRemoveItem = useCallback((item) => {
        LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
        setVisibleCategoriesOrder((prev) => prev.filter((prevItem) => prevItem.id !== item.id));
        setHiddenCategories((prev) => [item, ...prev]);
    }, []);
    const onAddItem = useCallback((item) => {
        LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
        setHiddenCategories((prev) => prev.filter((prevItem) => prevItem.id !== item.id));
        setVisibleCategoriesOrder((prev) => [...prev, item]);
    }, []);
    const onMoveEnd = useCallback((newList) => {
        setVisibleCategoriesOrder([...newList]);
    }, []);
    return {
        visibleCategoriesOrder,
        hiddenCategories,
        handleDone,
        onRevertOrder,
        onRemoveItem,
        onAddItem,
        onMoveEnd,
    };
};
